// KPI — Vendite e fatturato (1), Analisi documenti (12), Statistica trasversale (15)
import React from "react";
import { Euro, ClipboardList, Sigma } from "lucide-react";
import { useFm, fmtKg, fmtInt, Bars } from "../bi/biShared";
import { Kpi, Group, KpiGrid, SubTitle, fmtNum } from "./kpiShared";

export default function KpiSales({ data }) {
  const fm = useFm();
  const F = data.formulas;
  const c = data.sales.current, dl = data.sales.delta_pct, st = data.docs_stats;
  return (
    <div className="space-y-4" data-testid="kpi-tab-sales">
      <Group num={1} title="Vendite e fatturato" icon={Euro} note={data.notes.ddt} testId="kpi-g1">
        <KpiGrid>
          <Kpi label="Fatturato" value={fm(c.revenue)} delta={dl.revenue} sub={`IVA incl. ${fm(c.revenue_gross)}`} formula={F.revenue} testId="kpi-revenue" accent />
          <Kpi label="Numero DDT" value={fmtInt(c.ddt_count)} delta={dl.ddt_count} formula={F.ddt_count} testId="kpi-ddt" />
          <Kpi label="Kg venduti" value={`${fmtKg(c.kg, 0)} kg`} delta={dl.kg} sub={`${fmtInt(c.pieces)} colli`} formula={F.kg} testId="kpi-kg" />
          <Kpi label="Prezzo medio di vendita" value={c.avg_price_kg != null ? `${fm(c.avg_price_kg)}/kg` : "—"} delta={dl.avg_price_kg} formula={F.avg_price} testId="kpi-avg-price" />
          <Kpi label="Valore medio DDT (AOV)" value={fm(c.avg_ddt_value)} delta={dl.avg_ddt_value} formula={F.aov} testId="kpi-aov" />
          <Kpi label="Kg medi per DDT" value={c.kg_per_ddt != null ? `${fmtKg(c.kg_per_ddt, 1)} kg` : "—"} delta={dl.kg_per_ddt} formula={F.kg_per_ddt} testId="kpi-kg-ddt" />
          <Kpi label="Fatturato medio giornaliero" value={fm(c.daily_revenue)} delta={dl.daily_revenue} sub={`${c.days} giorni`} formula={F.daily} testId="kpi-daily" />
        </KpiGrid>
      </Group>

      <Group num={12} title="Analisi documenti (DDT)" icon={ClipboardList} note={data.notes.ddt} testId="kpi-g12">
        <KpiGrid>
          <Kpi label="DDT minimo" value={fm(st.min)} formula={F.min} testId="kpi-doc-min" />
          <Kpi label="DDT massimo" value={fm(st.max)} formula={F.max} testId="kpi-doc-max" accent />
          <Kpi label="Mediana valore DDT" value={fm(st.median)} formula={F.median} testId="kpi-doc-median" />
          <Kpi label="Deviazione standard" value={fm(st.stdev)} formula={F.stdev} testId="kpi-doc-stdev" />
        </KpiGrid>
        <SubTitle>Distribuzione DDT per fascia di valore</SubTitle>
        <Bars data={st.bands.map((b) => ({ ...b, key: b.label }))} valueKey="count" formatValue={(v) => `${fmtInt(v)} DDT`} color="#1c4e8a" testIdPrefix="kpi-band" />
      </Group>

      <Group num={15} title="Statistica trasversale" icon={Sigma} testId="kpi-g15">
        <KpiGrid>
          <Kpi label="Media valore DDT" value={fm(st.mean)} formula={F.mean} testId="kpi-stat-mean" />
          <Kpi label="Percentile 25" value={fm(st.p25)} formula={F.percentile} testId="kpi-stat-p25" />
          <Kpi label="Percentile 75" value={fm(st.p75)} formula={F.percentile} testId="kpi-stat-p75" />
          <Kpi label="Percentile 90" value={fm(st.p90)} formula={F.percentile} testId="kpi-stat-p90" />
          <Kpi label="Correlazione volume–prezzo" value={st.corr_kg_price != null ? fmtNum(st.corr_kg_price, 2) : "—"} sub={`${fmtInt(st.corr_points)} clienti`} formula={F.corr} testId="kpi-stat-corr" accent />
        </KpiGrid>
      </Group>
    </div>
  );
}
